<template>
  <div>
    <div
      class="coms-goods flex-start"
      v-for="(goods,index) in goodsList"
      @click="goGoodsDetail(goods.url.name, goods.url.query.id)"
    >
      <img class="coms-left" :src="goods.goods.pic_url" />
      <div class="coms-right">
        <div class="coms-good-name">{{goods.goods.title}}</div>
        <div class="coms-good-detail flex-between">
          <div class="flex-start">
            <div class="good-normal-price">
              <span>¥</span>
              {{goods.goods.price_range[0]}}
            </div>
            <div class="good-thr-price">
              <span>¥</span>
              {{goods.goods.orig_price}}
            </div>
          </div>
          <div class="coms-sell-num">已售 {{goods.goods.sold_count+goods.goods.sold_show_count}}</div>
        </div>
        <div
          class="good-pri-earn"
          style="margin:4px 0 4px 0 "
          v-if="goods.goods.max_seller_reward>0"
        >分享可赚￥{{goods.goods.max_seller_reward}}</div>
        <div class="coms-tips" v-if="goods.goods.discount_tags.length>0">
          <div class="coms-tips-one flex-start" v-for="(tag, index) in goods.goods.discount_tags">
            <div
              class="coms-tips-type coms-tips-typeq"
              :style="'background:'+tag.color"
              v-html="tag.title"
            >{{tag.tag}}</div>
            {{tag.title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 小图 */

.coms-goods {
  padding: 0 10px 10px;
  margin-bottom: 10px;
  align-items: flex-start;
}

.coms-left {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

.coms-good-name {
  color: #333;
  font-size: 14px;
  margin-bottom: 20px;
}

.coms-right {
  margin-left: 10px;
  width: 240px;
}

.coms-sell-num {
  color: #999;
  font-size: 12px;
}

.coms-tips {
  border-top: 1px solid #efefef;
  font-size: 12px;
  color: #666666;
}

.coms-tips-type {
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 2px;
  color: #fff;
  margin-right: 2.5px;
}
.coms-tips-one {
  margin-top: 5px;
}
.coms-tips-one text {
  color: #fd2840;
}
.coms-tips-typek {
  background: #273040;
}
.coms-tips-typej {
  background: #42bd56;
}
.coms-tips-typet {
  background: #ff7500;
}
.coms-tips-typeq {
  background: #ff5a5f;
}
.good-normal-price {
  color: #fd2840;
  font-size: 17px;
  font-weight: 500;
}

.good-normal-price text {
  font-size: 12px;
}

.good-thr-price {
  color: #999;
  font-size: 12px;
  margin-left: 7.5px;
  text-decoration: line-through;
}

.good-pri-earn {
  width: auto;
  padding: 2px 2px;
  background: rgba(253, 232, 234, 1);
  border-radius: 2px;
  /* border:2rpx solid rgba(253,40,64,1); */
  font-size: 12px;
  color: #fd2840;
  text-align: center;
  margin-left: 7.5px;
}
</style>

<script>
export default {
  name: "GoodsItem1",
  components: {},
  props: {
    goodsList: {
      type: Array,
      default: []
    }
  },

  data: function() {
    return {};
  },

  methods: {
    goGoodsDetail(url, id) {
      rbLink({
        name: url.substring(0, 1).toUpperCase() + url.substring(1),
        query: {
          id: id
        }
      });
    }
  },

  filters: {}
};
</script>




// WEBPACK FOOTER //
// GoodsItem1.vue?236ade78